import {
    Show,
    SimpleShowLayout,
    TextField,
    BooleanField,
    NumberField,
    DateField,
    ReferenceField,
    EditButton,
    TopToolbar,
    FunctionField,
    RichTextField,
} from 'react-admin';

const CaseShowActions = () => (
    <TopToolbar>
        <EditButton/>
    </TopToolbar>
);

export const CaseShow = () => (
    <Show actions={<CaseShowActions/>}>
        <SimpleShowLayout>
            <TextField source="id"/>
            <TextField source="title"/>
            <TextField source="slug"/>
            <FunctionField 
                label="Map Image" 
                render={(record: any) => 
                    record.mapImage?.url ? (
                        <img 
                            src={record.mapImage.url} 
                            alt="Map" 
                            style={{ maxWidth: 200, maxHeight: 200, objectFit: 'contain' }} 
                        />
                    ) : (
                        <span>No image</span>
                    )
                } 
            />
            <FunctionField 
                label="Cover Image" 
                render={(record: any) => 
                    record.coverImage?.url ? (
                        <img 
                            src={record.coverImage.url} 
                            alt="Cover" 
                            style={{ maxWidth: 200, maxHeight: 200, objectFit: 'contain' }} 
                        />
                    ) : (
                        <span>No image</span>
                    )
                } 
            />
            <TextField source="from"/>
            <TextField source="to"/>
            <TextField source="machine"/>
            <FunctionField 
                label="Slider Images" 
                render={(record: any) => 
                    record.sliderImages && record.sliderImages.length > 0 ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {record.sliderImages.map((sliderImage: any, index: number) => (
                                <img 
                                    key={index}
                                    src={sliderImage.media?.url} 
                                    alt={`Slider ${index + 1}`} 
                                    style={{ width: 100, height: 100, objectFit: 'cover' }} 
                                />
                            ))}
                        </div>
                    ) : (
                        <span>No slider images</span>
                    )
                } 
            />
            <NumberField source="time" label="Время доставки (дни)"/>
            <TextField source="logisticPrice"/>
            <TextField source="exploitationPrice"/>
            <FunctionField 
                label="Big Map Image" 
                render={(record: any) => 
                    record.bigMapImage?.url ? (
                        <img 
                            src={record.bigMapImage.url} 
                            alt="Big Map" 
                            style={{ maxWidth: 300, maxHeight: 300, objectFit: 'contain' }} 
                        />
                    ) : (
                        <span>No big map image</span>
                    )
                } 
            />
            <TextField source="descriptionTitle"/>
            <RichTextField source="description"/>
            <ReferenceField source="categoryId" reference="case-categories">
                <TextField source="name"/>
            </ReferenceField>
            <BooleanField source="isActive"/>
            <NumberField source="sortOrder"/>
            <DateField source="createdAt" showTime/>
            <DateField source="updatedAt" showTime/>
        </SimpleShowLayout>
    </Show>
);
